import { Box } from "@mui/material";
import { HomeHealthNotificationPreferencesContainer } from "@src/appV2/redesign/FacilityUser/HomeHealthNotificationPreferences/HomeHealthNotificationPreferencesContainer";
import { type HomeHealthUser } from "@src/appV2/redesign/FacilityUser/HomeHealthNotificationPreferences/types";
import { Dialog } from "@src/appV2/redesign/components/Dialog";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { Text } from "@src/appV2/redesign/components/Text";
import { BerlinThemeProvider } from "@src/appV2/redesign/theme/ThemeProvider";
import { ModalStatus, type UseModalState } from "@src/lib/ui-react";
import { useMemo } from "react";

interface HomeHealthNotificationPreferencesDialogProps {
  isOpen: boolean;
  user: HomeHealthUser | undefined;
  workplaceId: string;
  performedBy?: string;
  onSaved?: () => void;
  onClose: () => void;
  onDone: () => void;
}

export function HomeHealthNotificationPreferencesDialog(
  props: HomeHealthNotificationPreferencesDialogProps
) {
  const { isOpen, user, workplaceId, performedBy, onSaved, onClose, onDone } = props;

  const modalState: UseModalState = useMemo(
    () => ({
      modalStatus: isOpen ? ModalStatus.OPEN : ModalStatus.CLOSED,
      modalIsOpen: isOpen,
      modalIsClosed: !isOpen,
      setModalStatus: () => undefined,
      openModal: () => undefined,
      closeModal: () => undefined,
    }),
    [isOpen]
  );

  return (
    <BerlinThemeProvider>
      <Dialog
        modalState={modalState}
        width={640}
        headerContent={
          <Box
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: theme.spacing(5),
              paddingX: theme.spacing(5),
              paddingY: theme.spacing(3),
              borderBottom: `1px solid ${theme.palette.border?.base}`,
            })}
          >
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Text bold sx={{ whiteSpace: "normal" }}>
                Notification Preferences
              </Text>
            </Box>
            <IconButton
              aria-label="Close dialog"
              iconType="close"
              size="medium"
              variant="outlined"
              onClick={onClose}
            />
          </Box>
        }
        footerContent={<DialogFooter primaryAction={{ label: "Done", onClick: onDone }} />}
        onClose={onClose}
      >
        <HomeHealthNotificationPreferencesContainer
          performedBy={performedBy}
          user={user}
          workplaceId={workplaceId}
          onSaved={onSaved}
        />
      </Dialog>
    </BerlinThemeProvider>
  );
}
